export default "__VITE_ASSET__DWb1uOod__"